export enum BadgeType {
  RECOMMENDED = 1,
  DEPRECATED = 2,
  UNSTABLE = 3,
  NEW = 4,
}

export interface Badge {
  id?: number;
  type: BadgeType;
  message?: string;
  sdkId?: number;
  adapterId?: number;
  createdAt?: string;
}

export const BadgeTypeName: Record<BadgeType, string> = {
  [BadgeType.RECOMMENDED]: "Recommended",
  [BadgeType.DEPRECATED]: "Deprecated",
  [BadgeType.UNSTABLE]: "Unstable",
  [BadgeType.NEW]: "New",
};

export const BadgeTypeColor: Record<BadgeType, string> = {
  [BadgeType.RECOMMENDED]: "green",
  [BadgeType.DEPRECATED]: "red",
  [BadgeType.UNSTABLE]: "orange",
  [BadgeType.NEW]: "blue",
};